function addTimeFn(ms) {
    return function (d, n) {
        if (d === null)
            return null;
        if (!isFinite(n))
            return d;
        return new Date(d.getTime() + ms * n);
    };
}
function addFn(keyGet, keySet) {
    return function (d, n) {
        if (d === null)
            return null;
        if (!isFinite(n))
            return d;
        var result = new Date(d.getTime());
        result[keySet](result[keyGet]() + n);
        return result;
    };
}
export var addMilliseconds = addTimeFn(1 /* Milliseconds */);
export var addSeconds = addTimeFn(1000 /* Seconds */);
export var addMinutes = addTimeFn(60000 /* Minutes */);
export var addHours = addTimeFn(3600000 /* Hours */);
export var addDate = addFn('getDate', 'setDate');
export var addMonth = addFn('getMonth', 'setMonth');
export var addYear = addFn('getFullYear', 'setFullYear');
export var addUTCMilliseconds = addFn('getUTCMilliseconds', 'setUTCMilliseconds');
export var addUTCSeconds = addFn('getUTCSeconds', 'setUTCSeconds');
export var addUTCMinutes = addFn('getUTCMinutes', 'setUTCMinutes');
export var addUTCHours = addFn('getUTCHours', 'setUTCHours');
export var addUTCDate = addFn('getUTCDate', 'setUTCDate');
export var addUTCMonth = addFn('getUTCMonth', 'setUTCMonth');
export var addUTCYear = addFn('getUTCFullYear', 'setUTCFullYear');



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/add/add-unit.js
// module id = null
// module chunks = 